// Generouted, changes to this file will be overriden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/access-denied`
  | `/exam-courses`
  | `/exam-courses/:courseId`
  | `/exam-courses/:courseId/qconfig-generators`
  | `/exam-courses/:courseId/qconfig-generators/:qConfigGeneratorId`
  | `/exam-courses/:courseId/qconfig-generators/create`
  | `/exam-courses/:courseId/qconfigs`
  | `/exam-courses/:courseId/qconfigs/:qconfigId`
  | `/exam-courses/:courseId/qconfigs/:qconfigId/*`
  | `/exam-courses/:courseId/qconfigs/:qconfigId/activity-log`
  | `/exam-courses/:courseId/qconfigs/:qconfigId/details`
  | `/exam-courses/:courseId/qconfigs/:qconfigId/settings`
  | `/exam-courses/:courseId/qset-generator`
  | `/exam-courses/:courseId/qsets`
  | `/exam-courses/:courseId/qsets/:qSetId`
  | `/exam-courses/:courseId/qsets/:qSetId/activity-log`
  | `/exam-courses/:courseId/qsets/:qSetId/details`
  | `/exam-courses/:courseId/qsets/:qSetId/exam-details`
  | `/exam-courses/:courseId/qsets/:qSetId/review-history`
  | `/exam-courses/:courseId/qsets/generator/results`
  | `/exam-courses/:courseId/qsets/similarity-check/results`
  | `/exam-courses/:courseId/qsets/similarity-check/results/:resultId/:comparisonId`
  | `/landing`
  | `/login`
  | `/my-task/qset-review/:taskId`
  | `/my-task/qset-review/:taskId/qset/:qSetId/review-result`
  | `/my-task/qset-review/:taskId/qset/:qSetId/review-result/exam-details`
  | `/my-task/qset-review/:taskId/subtask/:subTaskId`
  | `/my-task/qset-review/:taskId/subtask/:subTaskId/review-result`
  | `/my-task/qset-review/:taskId/subtask/:subTaskId/task-details`
  | `/my-task/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details`
  | `/my-task/question-creation/:taskId`
  | `/my-task/question-creation/:taskId/details`
  | `/my-task/question-creation/:taskId/item-set/:questionId`
  | `/my-task/question-creation/:taskId/item-set/:questionId/:subQuestionId`
  | `/my-task/question-creation/:taskId/item-set/:questionId/create`
  | `/my-task/question-creation/:taskId/item-set/create`
  | `/my-task/question-creation/:taskId/question-list`
  | `/my-task/question-creation/:taskId/single/:questionId`
  | `/my-task/question-creation/:taskId/single/create`
  | `/my-task/question-review/:taskId`
  | `/my-task/question-review/:taskId/question-details/:questionId`
  | `/qbank-structures`
  | `/qbank-structures/:structureId`
  | `/qbank-structures/:structureId/activity-log`
  | `/qbank-structures/:structureId/dashboard`
  | `/qbank-structures/:structureId/los`
  | `/qbank-structures/:structureId/los/:losId/questions`
  | `/qbank-structures/:structureId/qcontents`
  | `/qbank-structures/:structureId/qcontents/item-set/:questionId`
  | `/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId`
  | `/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId/activity-log`
  | `/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId/question-usage`
  | `/qbank-structures/:structureId/qcontents/item-set/:questionId/activity-log`
  | `/qbank-structures/:structureId/qcontents/item-set/:questionId/create`
  | `/qbank-structures/:structureId/qcontents/item-set/create`
  | `/qbank-structures/:structureId/qcontents/single/:contentId`
  | `/qbank-structures/:structureId/qcontents/single/:contentId/activity-log`
  | `/qbank-structures/:structureId/qcontents/single/:contentId/question-usage`
  | `/qbank-structures/:structureId/qcontents/single/create`
  | `/qbank-structures/:structureId/setting`
  | `/qbank-structures/:structureId/structure`
  | `/qbank-structures/search-by-keywords`
  | `/qbank-structures/search-by-keywords/qid`
  | `/task-management`
  | `/task-management/qset-review`
  | `/task-management/qset-review/:taskId`
  | `/task-management/qset-review/:taskId/qset/:qSetId/review-result`
  | `/task-management/qset-review/:taskId/qset/:qSetId/review-result/exam-details`
  | `/task-management/qset-review/:taskId/subtask/:subTaskId`
  | `/task-management/qset-review/:taskId/subtask/:subTaskId/review-result`
  | `/task-management/qset-review/:taskId/subtask/:subTaskId/task-details`
  | `/task-management/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details`
  | `/task-management/question-creation`
  | `/task-management/question-creation/:taskId`
  | `/task-management/question-creation/:taskId/details`
  | `/task-management/question-creation/:taskId/item-set/:questionId`
  | `/task-management/question-creation/:taskId/item-set/:questionId/:subQuestionId`
  | `/task-management/question-creation/:taskId/item-set/:questionId/create`
  | `/task-management/question-creation/:taskId/item-set/create`
  | `/task-management/question-creation/:taskId/question-list`
  | `/task-management/question-creation/:taskId/single/:questionId`
  | `/task-management/question-creation/:taskId/single/create`
  | `/task-management/question-creation/create`
  | `/task-management/question-review`
  | `/task-management/question-review/:taskId`
  | `/task-management/question-review/:taskId/question-details/:questionId`
  | `/task-management/question-review/create`
  | `/user-not-active`

export type Params = {
  '/exam-courses/:courseId': { courseId: string }
  '/exam-courses/:courseId/qconfig-generators': { courseId: string }
  '/exam-courses/:courseId/qconfig-generators/:qConfigGeneratorId': { courseId: string; qConfigGeneratorId: string }
  '/exam-courses/:courseId/qconfig-generators/create': { courseId: string }
  '/exam-courses/:courseId/qconfigs': { courseId: string }
  '/exam-courses/:courseId/qconfigs/:qconfigId': { courseId: string; qconfigId: string }
  '/exam-courses/:courseId/qconfigs/:qconfigId/*': { courseId: string; qconfigId: string; '*': string }
  '/exam-courses/:courseId/qconfigs/:qconfigId/activity-log': { courseId: string; qconfigId: string }
  '/exam-courses/:courseId/qconfigs/:qconfigId/details': { courseId: string; qconfigId: string }
  '/exam-courses/:courseId/qconfigs/:qconfigId/settings': { courseId: string; qconfigId: string }
  '/exam-courses/:courseId/qset-generator': { courseId: string }
  '/exam-courses/:courseId/qsets': { courseId: string }
  '/exam-courses/:courseId/qsets/:qSetId': { courseId: string; qSetId: string }
  '/exam-courses/:courseId/qsets/:qSetId/activity-log': { courseId: string; qSetId: string }
  '/exam-courses/:courseId/qsets/:qSetId/details': { courseId: string; qSetId: string }
  '/exam-courses/:courseId/qsets/:qSetId/exam-details': { courseId: string; qSetId: string }
  '/exam-courses/:courseId/qsets/:qSetId/review-history': { courseId: string; qSetId: string }
  '/exam-courses/:courseId/qsets/generator/results': { courseId: string }
  '/exam-courses/:courseId/qsets/similarity-check/results': { courseId: string }
  '/exam-courses/:courseId/qsets/similarity-check/results/:resultId/:comparisonId': { courseId: string; resultId: string; comparisonId: string }
  '/my-task/qset-review/:taskId': { taskId: string }
  '/my-task/qset-review/:taskId/qset/:qSetId/review-result': { taskId: string; qSetId: string }
  '/my-task/qset-review/:taskId/qset/:qSetId/review-result/exam-details': { taskId: string; qSetId: string }
  '/my-task/qset-review/:taskId/subtask/:subTaskId': { taskId: string; subTaskId: string }
  '/my-task/qset-review/:taskId/subtask/:subTaskId/review-result': { taskId: string; subTaskId: string }
  '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details': { taskId: string; subTaskId: string }
  '/my-task/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details': { taskId: string; subTaskId: string }
  '/my-task/question-creation/:taskId': { taskId: string }
  '/my-task/question-creation/:taskId/details': { taskId: string }
  '/my-task/question-creation/:taskId/item-set/:questionId': { taskId: string; questionId: string }
  '/my-task/question-creation/:taskId/item-set/:questionId/:subQuestionId': { taskId: string; questionId: string; subQuestionId: string }
  '/my-task/question-creation/:taskId/item-set/:questionId/create': { taskId: string; questionId: string }
  '/my-task/question-creation/:taskId/item-set/create': { taskId: string }
  '/my-task/question-creation/:taskId/question-list': { taskId: string }
  '/my-task/question-creation/:taskId/single/:questionId': { taskId: string; questionId: string }
  '/my-task/question-creation/:taskId/single/create': { taskId: string }
  '/my-task/question-review/:taskId': { taskId: string }
  '/my-task/question-review/:taskId/question-details/:questionId': { taskId: string; questionId: string }
  '/qbank-structures/:structureId': { structureId: string }
  '/qbank-structures/:structureId/activity-log': { structureId: string }
  '/qbank-structures/:structureId/dashboard': { structureId: string }
  '/qbank-structures/:structureId/los': { structureId: string }
  '/qbank-structures/:structureId/los/:losId/questions': { structureId: string; losId: string }
  '/qbank-structures/:structureId/qcontents': { structureId: string }
  '/qbank-structures/:structureId/qcontents/item-set/:questionId': { structureId: string; questionId: string }
  '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId': { structureId: string; questionId: string; subQuestionId: string }
  '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId/activity-log': { structureId: string; questionId: string; subQuestionId: string }
  '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId/question-usage': { structureId: string; questionId: string; subQuestionId: string }
  '/qbank-structures/:structureId/qcontents/item-set/:questionId/activity-log': { structureId: string; questionId: string }
  '/qbank-structures/:structureId/qcontents/item-set/:questionId/create': { structureId: string; questionId: string }
  '/qbank-structures/:structureId/qcontents/item-set/create': { structureId: string }
  '/qbank-structures/:structureId/qcontents/single/:contentId': { structureId: string; contentId: string }
  '/qbank-structures/:structureId/qcontents/single/:contentId/activity-log': { structureId: string; contentId: string }
  '/qbank-structures/:structureId/qcontents/single/:contentId/question-usage': { structureId: string; contentId: string }
  '/qbank-structures/:structureId/qcontents/single/create': { structureId: string }
  '/qbank-structures/:structureId/setting': { structureId: string }
  '/qbank-structures/:structureId/structure': { structureId: string }
  '/task-management/qset-review/:taskId': { taskId: string }
  '/task-management/qset-review/:taskId/qset/:qSetId/review-result': { taskId: string; qSetId: string }
  '/task-management/qset-review/:taskId/qset/:qSetId/review-result/exam-details': { taskId: string; qSetId: string }
  '/task-management/qset-review/:taskId/subtask/:subTaskId': { taskId: string; subTaskId: string }
  '/task-management/qset-review/:taskId/subtask/:subTaskId/review-result': { taskId: string; subTaskId: string }
  '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details': { taskId: string; subTaskId: string }
  '/task-management/qset-review/:taskId/subtask/:subTaskId/task-details/exam-details': { taskId: string; subTaskId: string }
  '/task-management/question-creation/:taskId': { taskId: string }
  '/task-management/question-creation/:taskId/details': { taskId: string }
  '/task-management/question-creation/:taskId/item-set/:questionId': { taskId: string; questionId: string }
  '/task-management/question-creation/:taskId/item-set/:questionId/:subQuestionId': { taskId: string; questionId: string; subQuestionId: string }
  '/task-management/question-creation/:taskId/item-set/:questionId/create': { taskId: string; questionId: string }
  '/task-management/question-creation/:taskId/item-set/create': { taskId: string }
  '/task-management/question-creation/:taskId/question-list': { taskId: string }
  '/task-management/question-creation/:taskId/single/:questionId': { taskId: string; questionId: string }
  '/task-management/question-creation/:taskId/single/create': { taskId: string }
  '/task-management/question-review/:taskId': { taskId: string }
  '/task-management/question-review/:taskId/question-details/:questionId': { taskId: string; questionId: string }
}

export type ModalPath = `/add-qbank-to-qconfig` | `/confirm-remove-user-from-qbank-structure` | `/create-qconfig`

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
